/**
 * Build Shopify admin URLs that work inside embedded apps.
 *
 * Extracts the store handle and constructs proper HTTPS admin links
 * instead of the unreliable shopify:// scheme.
 */

let cachedBase: string | null = null

function getStoreHandle(): string | null {
    // 1. URL params — Shopify passes ?shop= on initial load
    const params = new URLSearchParams(window.location.search)
    const shop = params.get('shop')
    if (shop) return shop.replace('.myshopify.com', '')

    // 2. ancestorOrigins — available in Chrome inside iframes
    try {
        const origin = window.location.ancestorOrigins?.[0] || ''
        const match = origin.match(/admin\.shopify\.com\/store\/([^/]+)/)
        if (match) return match[1]
    } catch { /* cross-origin blocked */ }

    // 3. document.referrer — set after full page load
    const refMatch = document.referrer.match(/admin\.shopify\.com\/store\/([^/]+)/)
    if (refMatch) return refMatch[1]

    // 4. Check if shop was stored from a previous successful resolution
    try {
        const stored = sessionStorage.getItem('bnplx_store_handle')
        if (stored) return stored
    } catch { /* storage blocked */ }

    return null
}

function getAdminBase(): string {
    if (cachedBase) return cachedBase

    const handle = getStoreHandle()
    if (handle) {
        cachedBase = `https://admin.shopify.com/store/${handle}`
        // Persist for SPA navigations where URL params are lost
        try { sessionStorage.setItem('bnplx_store_handle', handle) } catch {}
        return cachedBase
    }

    // Don't cache the fallback — try again next time
    return 'shopify://admin'
}

export function adminUrl(path: string): string {
    return `${getAdminBase()}/${path.replace(/^\//, '')}`
}
